import * as Sentry from "@sentry/react";
import { localStorageService } from "@shared/services";

export class SentryService {
  static sendMessage(message: string) {
    if (process.env.NODE_ENV === "production") {
      try {
        const lobbyInfo = localStorageService.getData("lobby-info") ?? "";
        const parsedInfo = JSON.parse(lobbyInfo) ?? {};

        Sentry.setTags({
          error_message: message,
          ...parsedInfo,
        });

        Sentry.captureMessage(
          `LOBBY ERROR [COOKIE: ${btoa(window.document.cookie.toString())}]`
        );
      } catch (error: unknown) {
        console.error((error as Error)?.message);
      }
    }
  }
}
